import { fork, all, put, takeLatest, select } from 'redux-saga/effects'
import cartSaga from './cart'
import wishlistSaga from './wishlist'
import tokenSaga from './token'
import {
    CHECK_ACCOUNT_DETAILS,
    GLOBAL_CONTENT_LOADED,
    setAccount,
    clearAccount,
    getWishlist,
    checkAccessToken
} from "../../actions"
import {getGlobalContent} from "../../selectors"
import {canUseDom} from '../../utils/dom'

function getLocalStorageAuthInfo() {
    var authInfo = window.localStorage.getItem('ngStorage-ti_auth');
    return authInfo && JSON.parse(authInfo);
}

function* checkAccount(action) {
    // Do not check the token on the server side, we will get this one the page is loaded
    if(!canUseDom) return;

    const global = yield select(getGlobalContent);
    if(!global) return;

    yield put( getWishlist() );

    var authInfo = getLocalStorageAuthInfo();
    if(!authInfo || authInfo.isGuest === true) {
        yield put( clearAccount() );
        return;
    }

    yield put( setAccount(authInfo) );
    yield put( checkAccessToken() );
}

function* checkAccountOnGlobalContentLoadedSaga() {
    yield takeLatest(GLOBAL_CONTENT_LOADED, checkAccount);
}

function* checkAccountSaga() {
    yield takeLatest(CHECK_ACCOUNT_DETAILS, checkAccount);
}

function* accountSaga() {
    yield all([
        fork(checkAccountSaga),
        fork(checkAccountOnGlobalContentLoadedSaga),
        fork(tokenSaga),
        fork(wishlistSaga),
        fork(cartSaga)
    ])
}

export default accountSaga;


// WEBPACK FOOTER //
// ./src/sagas/account/index.js